<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Edit Item Details
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="Name">
          <d-input v-model="form.name" />
        </d-field>
        <d-field label="Description">
          <l-html-editor v-model="form.description" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$emit('close')">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Save Changes
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import { updateItem } from '@resources/scripts/services/contentListingItemsApi.service';
  import { showErrorToast } from '@services/errorHandling.service';

  export default {
    props: {
      file: {
        type: Object,
        default: () => ({}),
      },
      contentListing: {
        type: Object,
        default: () => ({}),
      },
    },

    emits: ['close', 'saved'],

    data() {
      return {
        saving: false,
        form: {
          name: '',
          description: '',
          categorized: false,
          type: '',
        },
      };
    },

    mounted() {
      this.form = JSON.parse(JSON.stringify(this.file));
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          await updateItem(this.form.id, this.form, this.contentListing.type);
          this.$emit('saved');
          this.$emit('close');
        } catch (error) {
          showErrorToast(error);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>